import * as React from 'react';
import * as _ from 'lodash';
import {
  ControlState,
  ControlStyleClass,
  ControlValidation,
  EmailConfiguration,
  Logging,
  renderEdit,
  validateDomainName,
} from '@vcd-ecm-ui/Common';
import { VtxButton, VtxIcon, VtxTooltip } from '@vertexinc/vtx-ui-react-component-library';
import Step1Props from './Step1Props.interface';
import Footer from '../Footer/Footer';
import '../../../common-correspondence.scss';
import '../../configuration.scss';
import { DefaultDomainName } from '../../useConfiguration';

const styles: ControlStyleClass = null;

const state: ControlState = {
  editable: true,
  disabled: false,
  readOnly: false,
};

const validation: ControlValidation = {
  requiredFields: ['domain'],
  customMessages: [],
};

const Step1 = ({
  gatewayEndPoint,
  configuration,
  onBack,
  onCancel,
  onNext,
}: Step1Props): JSX.Element => {
  const [domain, setDomain] = React.useState(configuration?.domain);

  const saveConfiguration = (): void => {
    const copyConfiguration: EmailConfiguration = _.cloneDeep(configuration);
    copyConfiguration.domain = domain;

    onNext(copyConfiguration);
  };

  const validateStep = (): boolean => {
    if (!domain) {
      return false;
    }

    if (!validateDomainName(domain)) {
      return false;
    }

    if (domain.toLowerCase().includes(DefaultDomainName.toLowerCase())) {
      return false;
    }

    return true;
  };

  // eslint-disable-next-line arrow-body-style
  const infoTooltip = (tooltip: string) : JSX.Element => {
    return (
      <VtxTooltip title={tooltip}>
        <VtxIcon type="info-circle" fontSize={16} color="gray" className="infoTooltip" />
      </VtxTooltip>
    );
  };

  const backVisible = false;
  const backEnabled = true;
  const nextVisible = true;
  const nextEnabled = validateStep();
  const domainTooltip = 'The Domain Tooltip will go here.\r\nIt can be very long and consist of multiple lines.';

  validation.customMessages = [];

  if (domain && !validateDomainName(domain)) {
    validation.customMessages = [...validation.customMessages,
      { field: 'domain', message: 'Invalid Domain Name entered', type: 'Error' }];
  }

  if (domain && domain.toLowerCase().includes(DefaultDomainName.toLowerCase())) {
    validation.customMessages = [...validation.customMessages,
      { field: 'domain', message: `The default domain name '${DefaultDomainName}' cannot be entered.`, type: 'Error' }];
  }

  const cancelVisible = true;
  const cancelEnabled = true;

  return (
    <>
      <div className="stepContent">
        <div className="descriptionHeading">
          Domain Authentication
        </div>
        <div className="descriptionText">
          Enter The Domain Correspondence will be sent From.
        </div>
        <br />
        <br />
        {renderEdit(66, 'domain', 'Domain Name*', 'text', 'Example: vertex.com', domain, setDomain,
          state, styles, validation, null, infoTooltip(domainTooltip))}
      </div>
      <Footer
        onBack={onBack}
        backVisible={backVisible}
        backEnabled={backEnabled}
        onCancel={onCancel}
        cancelVisible={cancelVisible}
        cancelEnabled={cancelEnabled}
        onNext={saveConfiguration}
        nextVisible={nextVisible}
        nextEnabled={nextEnabled}
      />
    </>
  );
};

export default Step1;
